// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8vmXX","title":"styles_title__apFeh","graph":"styles_graph__ckfIP","wrapper-thumb":"styles_wrapper-thumb__9WAI7","cta":"styles_cta__b3jrD"};